import type { AppSeoSportsData } from '@mobi/sports-offering/helpers/hostHelpers/types'
import { useAppSeo } from '../useAppSeo'

/**
 * Sports-offering SEO component: maps domain inputs to generic app SEO.
 * Injected by host (MainSportsOffering) through hostHelpers.
 */
export const useAppSeoForSports = ({ page, data }: AppSeoSportsData) => {
  let title = 'Sports Betting | TABtouch'
  let description =
    'Bet on AFL, NRL, cricket, soccer and more with TABtouch. Explore odds, same game multis and live sports betting markets.'

  if (page === 'sports') {
    const { sportName } = data
    const sport = sportName ?? 'Sports'
    title = `${sport} Betting | TABtouch`
    description = `Browse ${sport} betting markets with TABtouch. Live betting, odds, fixtures and match previews.`
  }

  if (page === 'events') {
    const { competitionName: competition } = data
    title = `${competition} Betting | TABtouch`
    description = `Explore ${competition} betting odds, fixtures, live markets and match previews with TABtouch.`
  }

  if (page === 'event-card') {
    const { awayName, homeName } = data
    const teams = awayName ? `${awayName} - ${homeName}` : homeName
    title = `${teams} Odds | TABtouch`
    description = `View odds, head-to-head markets and same game multis for ${teams} with TABtouch sports betting.`
  }

  useAppSeo({ title, description })
}
